import classnames from 'classnames';

import { cn } from 'utils';

interface Props {
  menuList: string[];
  selectedMenuIndex: number;
  onClickTab: (index: number) => void;
}

const MenuButton = ({ menuList, selectedMenuIndex, onClickTab }: Props) => {
  return (
    <div className="w-full">
      <div className={cn('flex w-full justify-center flex-row gap-1', 'md:px-6')}>
        {menuList.map((menu, index) => (
          <button
            key={`${menu}-${index}`}
            className={cn('py-2.5 px-5 w-full mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700', 'md:px-4', {
              'pb-2': index === selectedMenuIndex
            })}
            onClick={() => onClickTab(index)}
          >
            <span
              className={classnames(
                'text-nowrap text-body2 font-medium',
                {
                  'text-text-primary': index === selectedMenuIndex
                },
                {
                  'text-text-tertiary': index !== selectedMenuIndex
                }
              )}
            >
              {menu}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MenuButton;
